import React from "react";
import { Link } from "react-router-dom";
import { logoUrl } from "@/lib/api";

export default function Footer({ content }) {
  const c = content?.contact || {};
  return (
    <footer className="relative bg-base border-t border-line-2 py-14 px-5 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            {content?.brand?.logo_filename
              ? <img src={logoUrl(content.brand.logo_filename)} alt="LUVA Solutions" className="h-9 w-auto max-w-[120px] object-contain" />
              : <div className="w-9 h-9 bg-brand flex items-center justify-center text-white font-bold text-[14px]" style={{ borderRadius: 2 }}>LU</div>
            }
            <div>
              <div className="text-fg font-semibold leading-none">LUVA Solutions</div>
              <div className="text-mute text-[11px] tracking-wider mt-1">IT · BROADCASTING</div>
            </div>
          </div>
          <p className="text-mute text-[14px] leading-relaxed">Infraestructura IT gestionada, redes, ciberseguridad, servidores y broadcasting profesional. Buenos Aires, Argentina.</p>
        </div>
        <div>
          <div className="text-mute text-[11px] tracking-wider uppercase mb-4">Secciones</div>
          <ul className="space-y-2 text-[14px]">
            <li><a href="#servicios" className="text-fg-2 hover:text-fg">Servicios</a></li>
            <li><a href="#broadcasting" className="text-fg-2 hover:text-fg">Broadcasting</a></li>
            <li><a href="#galeria" className="text-fg-2 hover:text-fg">Trabajos</a></li>
            <li><a href="#clientes" className="text-fg-2 hover:text-fg">Clientes</a></li>
          </ul>
        </div>
        <div>
          <div className="text-mute text-[11px] tracking-wider uppercase mb-4">Contacto</div>
          <ul className="space-y-2 text-[14px]">
            <li><a href={`mailto:${c.email || "info@luva.ar"}`} className="text-fg-2 hover:text-fg">{c.email}</a></li>
            <li><a href={`https://wa.me/${c.whatsapp || "5491166861309"}`} target="_blank" rel="noreferrer" className="text-fg-2 hover:text-fg">{c.whatsapp_display}</a></li>
            <li className="text-mute">{c.address_line1}</li>
            <li className="text-mute">{c.address_line2}</li>
          </ul>
        </div>
        <div>
          <div className="text-mute text-[11px] tracking-wider uppercase mb-4">Acceso</div>
          <ul className="space-y-2 text-[14px]">
            {c.support_url && <li><a href={c.support_url} target="_blank" rel="noreferrer" className="text-fg-2 hover:text-fg">Portal de soporte →</a></li>}
            {c.cloud_url && <li><a href={c.cloud_url} target="_blank" rel="noreferrer" className="text-fg-2 hover:text-fg">Luva Cloud →</a></li>}
            <li><Link to="/admin" className="text-faint hover:text-fg text-[12px]">/admin →</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-line-2 flex flex-wrap items-center justify-between gap-3">
        <div className="text-mute text-[12px]">© {new Date().getFullYear()} LUVA Solutions · Buenos Aires, Argentina</div>
        <div className="text-mute text-[12px]">Hecho con disciplina, sin gimmicks.</div>
      </div>
    </footer>
  );
}
